import { isValidEmail } from 'utils/isValidEmail';
import createErrorHandler from 'utils/createErrorHandler';

function validateEditCrashCourseBatchInput(state, emails) {
  const [errors, addError] = createErrorHandler();

  const wrongEmails = [];

  emails.forEach((email) => {
    const output = isValidEmail(email.trim());
    if (!output) {
      wrongEmails.push(email);
    }
  });

  if (emails.length > 500) {
    addError('mentee_emails', 'Number of email ids should be less than 500');
  }

  if (emails.length === 0) {
    addError('mentee_emails', 'Please enter a valid email');
  }
  if (wrongEmails.length !== 0) {
    addError('mentee_emails', `Invalid format: ${wrongEmails.join(', ')}`);
  }

  if (!state.pastClassesStatus) {
    addError('past_classes_status', 'Please Select a valid status');
  }

  return errors;
}

export default validateEditCrashCourseBatchInput;
